import CheckoutBasket from './CheckoutBasket';
import CheckoutDelivery from './CheckoutDelivery';
import CheckoutPaySystem from './CheckoutPaySystem';
import CheckoutTotal from './CheckoutTotal';
import CheckoutUserInfo from './CheckoutUserInfo';

import IArResult from './IArResult';

export default class CheckoutComponent {
    static set arResult(value: IArResult) {
        this._arResult = value;
    }

    static get arResult() {
        return this._arResult;
    }

    private readonly BX?: never;

    private readonly ymaps?: never;

    private readonly boxberry?: never;

    static readonly dataType: string = 'json';

    static readonly ajaxAction: string = 'reloadComponents';

    private static _arResult: IArResult;

    private static lastScroll: any;

    // eslint-disable-next-line max-params
    constructor(arResult: object, BX: never, ymaps: never, boxberry: never) {
        CheckoutComponent.arResult = global.window.checkoutResult;
        global.window.BX.Sale.OrderAjaxComponent = CheckoutComponent;
        CheckoutComponent.arResult.MIM_ID = global.window.mimID;
        this.BX = BX;
        this.ymaps = ymaps;
        this.boxberry = boxberry;
    }

    init() {
        const checkoutTotal = new CheckoutTotal(this.BX);
        const checkoutBasket = new CheckoutBasket(this.BX);
        const checkoutDelivery = new CheckoutDelivery(
            this.BX,
            this.ymaps,
            this.boxberry
        );
        const checkoutUserInfo = new CheckoutUserInfo();
        const checkoutPaySystem = new CheckoutPaySystem(this.BX);

        checkoutUserInfo.init();
        checkoutTotal.init();
        checkoutBasket.init();
        checkoutDelivery.init();
        CheckoutDelivery.initDadata();
        checkoutPaySystem.init();
        this.bindEvents();
        CheckoutComponent.replaceBasket();
        CheckoutComponent.lastScroll = 0;
        if ($('#checkout').hasClass('order-mode')) {
            this.setOrderMode();
        }
    }

    bindEvents() {
        let self = this;
        $('label.license').on('click', function (e) {
            self.licenseCheck(e);
        });
        $(document).on(
            'click',
            '.basket-back-btn, .catalog-back-btn',
            function () {
                self.backButtonClick();
            }
        );
        $(window).on('resize', function () {
            CheckoutComponent.replaceBasket();
        });
        $(document).on('scroll', function () {
            self.scrollBlocks();
        });
        $('.gift-item').on('click', function (e) {
            CheckoutComponent.addGift(e);
        });
        $(document).on('click', '#modal-block-load-sku', function(e) {
            var itemId = $(this).attr('data-item');
            var skuId = $(this).attr('data-sku');
            var ruleId = $(this).attr('data-ruleId');
            var orderId = $(this).attr('data-orderId');
            CheckoutComponent.toggleGiftSku(itemId, skuId, ruleId, orderId);
            e.preventDefault();
        });
        $(document).on('click', '.add-gift-btn', function(e){
            CheckoutComponent.addGift(e);
        });
    }

    static addGift(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $item = $(e.target);
        console.log($item)
        if($item.hasClass('disabled') || $item.hasClass('not-avail')) {
            return false;
        }
        let skuId, itemId, ruleId, orderId, bModal = !$item.hasClass('gift-item');
        if(!bModal) {
            skuId = $item.attr('data-skuId');
            itemId = $item.attr('data-itemId');
            ruleId = $item.attr('data-ruleId');
            orderId = $item.attr('data-orderId');
            if(skuId) {
                CheckoutComponent.openGiftSkuModal(itemId, skuId, ruleId, orderId);
                return;
            }
        } else {
            itemId = $item.attr('data-product-id');
            ruleId = $item.attr('data-ruleId');
            orderId = $item.attr('data-orderId');
        }
        $item.addClass('disabled');
        $.post(
            '/?ajaxAction=addGift',
            {
                itemId:itemId,
                ruleId:ruleId,
                orderId:orderId,
            },
            function(data) {
                $item.removeClass('disabled');
                if(data.status == 1) {
                    if(orderId) {
                        document.location.href = document.location.href + '&GIFT_SUCCESS=Y';
                    } else {
                        if(bModal) {
                            $('#skuModal').find('.close').trigger('click');
                        }
                        CheckoutComponent.reloadComponents(['total', 'basket']);
                    }
                }
            },
            'json'
        );
    }

    static openGiftSkuModal(itemId:any, skuId:any, ruleId:any, orderId:any) {
        $.ajax({
            type: 'POST',
            data: {itemId: itemId, skuId: skuId, ruleId:ruleId, orderId:orderId, giftMode: true},
            url: '/ajax/modal_catalog_element.php',
            beforeSend: function () {
                if (!$(document.body).hasClass('preloader-state')) {
                    $(document.body).addClass('preloader-state');
                }
            },
            success: function (data) {
                $('.modal-body-for-sku').html(data);
                $('#skuModal').modal('show');
                $(document.body).removeClass('preloader-state');
                if ($(window).width() <= 566) {
                    $('body>.product-price').each(function(i, element) {
                        $(element).remove();
                    });
                    $('.product-price').appendTo('body');
                }
            },
            error: function (jqXHR, text, error) {
                $(document.body).removeClass('preloader-state');
            }
        });
    }

    static toggleGiftSku(itemId:any, skuId:any, ruleId:any, orderId:any) {
        $.ajax({
            type: 'POST',
            data: {itemId: itemId, skuId: skuId, ruleId:ruleId, orderId:orderId, giftMode: true},
            url: '/ajax/modal_catalog_element.php',
            beforeSend: function ()  {
                if (!$(document.body).hasClass('preloader-state')) {
                    $(document.body).addClass('preloader-state');
                }
            },
            success: function (data) {
                $('.modal-body-for-sku').html(data);
                $(document.body).removeClass('preloader-state');

                if ($(window).width() <= 566) {
                    $('body>.product-price').each(function(i, element) {
                        $(element).remove();
                    });
                    $('.product-price').appendTo('body');
                }
            },
            error: function (jqXHR, text, error) {
                $(document.body).removeClass('preloader-state');
            }
        });
    }

    backButtonClick() {
        if ($(window).width() > 767) {
            document.location.href = '/catalog/';
        } else {
            document.location.href = '/basket/';
        }
    }

    scrollBlocks() {
        if ($(window).width() > 767) {
            let $totalComponent = $('#total-component');
            let $header = $('#header');
            let totalComponentHeight = $totalComponent.height();
            let windowHeight = $(window).height();
            let headerHeight = $header.innerHeight();
            let scrollSize = $(window).scrollTop();
            let totalComponentPositionTop = parseInt(
                $totalComponent.css('top')
            );
            let scrollSpeedCoef =
                ($totalComponent.height() / $(window).height()) * 5;
            let val, needOffset;

            $totalComponent.css({
                position: 'sticky',
                top: headerHeight,
            });

            if (scrollSize < CheckoutComponent.lastScroll) {
                // up
                if (totalComponentPositionTop < headerHeight) {
                    val = totalComponentPositionTop + scrollSpeedCoef;
                    if (val > headerHeight) {
                        val = headerHeight;
                    }
                    $totalComponent.css('top', val + 'px');
                }
            } else {
                // down
                if (totalComponentHeight > windowHeight - headerHeight) {
                    needOffset =
                        headerHeight -
                        (totalComponentHeight - (windowHeight - headerHeight));
                    val = totalComponentPositionTop - scrollSpeedCoef;
                    if (val < needOffset) {
                        val = needOffset;
                    }
                    $totalComponent.css('top', val + 'px');
                }
            }
            CheckoutComponent.lastScroll = scrollSize;
        }
    }

    licenseCheck(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let $checkbox = $(e.target)
            .closest('.licence_block')
            .find('input[type="checkbox"]');
        if ($checkbox.prop('checked')) {
            $checkbox.prop('checked', false);
        } else {
            $('.licence_block').find('.error').hide();
            $checkbox.prop('checked', true);
        }
    }

    static reloadComponents(aComponents: Array<string>, reloadPrices?: any) {
        $('#checkout').addClass('process');
        let self = this;
        this.post(
            document.location.href,
            {
                checkoutAjaxAction: CheckoutComponent.ajaxAction,
                components: aComponents,
                result: this._arResult,
            },
            (data) => {
                let bRecalculateDelivery = false;
                for (const k in data) {
                    if (k != 'result') {
                        $('[id="' + k + '-component"]').html(data[k]);
                    }
                    if (k == 'basket') {
                        bRecalculateDelivery = true;
                    }
                }
                CheckoutComponent.arResult = data.result;
                CheckoutDelivery.initDadata();
                $('#checkout').removeClass('process');
                if (CheckoutComponent.arResult.BASKET.ITEMS.length == 0) {
                    document.location.reload();
                }
                CheckoutComponent.replaceBasket();
                if (bRecalculateDelivery) {
                    CheckoutDelivery.calculateAllDeliveryServices();
                    CheckoutDelivery.initSelectedDelivery();
                    CheckoutDelivery.prototype.setActivePaySystems();
                }
                CheckoutTotal.getBonusBalance();
                $(".gifts-list").owlCarousel({
                    nav: true,
                    autoWidth: true,
                });
                $('.gift-item').on('click', function (e) {
                    CheckoutComponent.addGift(e);
                });
                if(reloadPrices) {
                    CheckoutComponent.reloadPrices();
                }
                let event = new Event('reload-complete');
                document
                    .querySelector(CheckoutBasket.basketContainer)
                    .dispatchEvent(event);
            }
        );
    }

    static reloadPrices() {
        this.post(
            document.location.href,
            {
                checkoutBasketAjaxAction: 'getPrices',
            },
            (data) => {
                for(var itemId in data.ITEMS) {
                    $('.basket-item-price[data-basket-id="'+itemId+'"]')
                        .html(data.ITEMS[itemId].PRICE)
                        .closest('.grid-item')
                        .find('.price-old')
                        .html(data.ITEMS[itemId].OLD_PRICE);
                }
                $('.total-basket-price').html(data.TOTAL_PRICE);
            }
        );
    }

    setOrderMode() {
        $('#pagetitle').addClass('order-mode');
        $('.topic__heading').prepend(
            '<i class="basket-back-btn"></i> <span class="catalog-back-btn hidden-xs">Продолжить покупки</span>'
        );
        $('#navigation').hide();
    }

    static replaceBasket() {
        $('#total-component').find('.basket-grid').remove();
        $('.total-basket-title').text('');
        if ($(window).width() > 767) {
            $('.total-basket-title').text('Ваш заказ');
            $('#basket-component')
                .find('.basket-grid')
                .clone()
                .insertAfter('#total-component .total-basket-title')
                .find('.lazyloading')
                .removeClass('lazyloading');
        }
    }

    static async post(href: string, data: any, success: (data: any) => void) {
        let $orderBtn = $('.btn-order-save');
        $orderBtn.addClass('disabled');

        await Promise.resolve($.post(href, data, success, CheckoutComponent.dataType));

        $orderBtn.removeClass('disabled');
    }

    static onClick(el: string, f: any) {
        $(document).on('click', el, f);
    }

    /**
     * Атавизм Битрикса
     * @return {boolean} false
     */
    static sendRequest() {
        return false;
    }

    static changeCalendar(mindate : any) {
        const el = $('[id ^= "calendar_popup_"]');
        const links = el.find('.bx-calendar-cell');

        $('.bx-calendar-left-arrow').attr({
            onclick: '_checkout.CheckoutComponent.changeCalendar();',
        });
        $('.bx-calendar-right-arrow').attr({
            onclick: '_checkout.CheckoutComponent.changeCalendar();',
        });
        $('.bx-calendar-top-month').attr({
            onclick: '_checkout.CheckoutComponent.changeMonth();',
        });
        $('.bx-calendar-top-year').attr({
            onclick: '_checkout.CheckoutComponent.changeYear();',
        });
        const date = new Date();

        for (let i = 0; i < links.length; i++) {
            const atrDate = links[i].attributes['data-date'].value;
            const d = date.valueOf();
            const g = links[i].innerHTML;

            if (
                CheckoutComponent.arResult.DELIVERY.DELIVERY_DATE ==
                'current_day'
            ) {
                if (date - atrDate > 7 * 60 * 60 * 1000) {
                    $(`[data-date="${atrDate}"]`)
                        .addClass('bx-calendar-date-hidden disabled')
                        .removeClass('bx-calendar-active')
                        .on('click', function () {
                            return false;
                        })
                        .on('dblclick', function () {
                            return false;
                        });
                }
            } else {
                if (date - atrDate > 60 * 60 * 1000) {
                    $(`[data-date="${atrDate}"]`)
                        .addClass('bx-calendar-date-hidden disabled')
                        .removeClass('bx-calendar-active')
                        .on('click', function () {
                            return false;
                        })
                        .on('dblclick', function () {
                            return false;
                        });
                }
            }

            if(mindate) {
                if(atrDate < mindate*1000) {
                    $(`[data-date="${atrDate}"]`)
                        .addClass('bx-calendar-date-hidden disabled')
                        .removeClass('bx-calendar-active')
                        .on('click', function () {
                            return false;
                        })
                        .on('dblclick', function () {
                            return false;
                        });
                }
                if (atrDate - mindate*1000 > 24 * 60 * 60 * 1000 * 7) {
                    $(`[data-date="${atrDate}"]`).addClass(
                        'bx-calendar-date-hidden disabled'
                    );
                }
            } else {
                if (atrDate - date > 24 * 60 * 60 * 1000 * 7) {
                    $(`[data-date="${atrDate}"]`).addClass(
                        'bx-calendar-date-hidden disabled'
                    );
                }
            }
        }
    }

    static changeMonth() {
        const el = $('[id ^= "calendar_popup_month_"]'); // Найдем div  с календарем
        const links = el.find('.bx-calendar-month');

        for (let i = 0; i < links.length; i++) {
            const func = links[i].attributes.onclick.value;

            $(`[onclick="${func}"]`).attr({
                onclick: `${func}; _checkout.CheckoutComponent.changeCalendar();`,
            });
        }
    }

    static changeYear() {
        const el = $('[id ^= "calendar_popup_year_"]'); // Найдем div  с календарем
        const link = el.find('.bx-calendar-year-input');
        const func2 = link[0].attributes.onkeyup.value;

        $(`[onkeyup="${func2}"]`).attr({
            onkeyup: `${func2}; _checkout.CheckoutComponent.changeCalendar();`,
        });
        const links = el.find('.bx-calendar-year-number');

        for (let i = 0; i < links.length; i++) {
            const func = links[i].attributes.onclick.value;

            $(`[onclick="${func}"]`).attr({
                onclick: `${func}; _checkout.CheckoutComponent.changeCalendar();`,
            });
        }
    }
}
